<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-3 xtl tf-14"><span class="nav-back wt" onclick="recharge()"></span></div>
                            <div class="col-6 tfw-7 tf-18">Recharge</div>
                            <div class="col-3 xtr tf-14"><span onclick="rchl()">Help</span></div>
                            <div class="col-12 xtl tf-16 pt-2">Recharge Amount</div>
                            <div class="col-12 xtl tf-18 pb-2"> <span class="tf-36 tfw-7" id="rmt">420</span></div>
                        </div>
                        <div class="row">
                            <div class="col-12 xtl tfw-6 tf-16 mt-4 tfcdb">Select Payment Method</div>
                            <div class="col-12 mt-4">
                                <div class="row mr-0">
                                    <div class="col-12 rcalbx" id="dtaod">
                                        <div class="row rowvac h56 tfwr mcpl"
                                            onclick="return upiPay('bharatpe09910913151@yesbankltd','PhonePe')">
                                            <div class="col-10 xtl tf-12">
                                                <span class="phonepe-logo"></span>
                                                <span class="tfw-5 tf-16">PhonePe</span>
                                                <span class="ml-2 dipn" id="upx1">bharatpe09910913151@yesbankltd</span>
                                            </div>
                                            <div class="col-2 pt-1 xtc">
                                                <input type="radio" id="ppc">
                                            </div>
                                        </div>
                                        <div class="row rowvac h56 mcpl"
                                            onclick="return upiPay('bharatpe09910913151@yesbankltd','Paytm')">
                                            <div class="col-10 xtl tf-12">
                                                <span class="paytm-logo"></span>
                                                <span class="tfw-5 tf-16">Paytm</span>
                                                <span class="ml-2 dipn" id="upx2">bharatpe09910913151@yesbankltd</span>
                                            </div>
                                            <div class="col-2 pt-1 xtc">
                                                <input type="radio" id="payc">
                                            </div>
                                        </div>
                                        <div class="row rowvac h56 mcpl"
                                            onclick="return upiPay('bharatpe09910913151@yesbankltd','GPay')">
                                            <div class="col-10 xtl tf-12">
                                                <span class="gpay-logo"></span>
                                                <span class="tfw-5 tf-16">GPay</span>
                                                <span class="ml-2 dipn" id="upx3">bharatpe09910913151@yesbankltd</span>
                                            </div>
                                            <div class="col-2 pt-1 xtc">
                                                <input type="radio" id="gpc">
                                            </div>
                                        </div>
                                        <div class="row rowvac h56 mcpl"
                                            onclick="return upiPay('bharatpe09910913151@yesbankltd','UPI')">
                                            <div class="col-10 xtl tf-12 rcaupi">
                                                <span class="upi nxl"></span>
                                                <span class="tfw-5 tf-20">Apps</span>
                                                <span class="ml-2 dipn" id="upx4">bharatpe09910913151@yesbankltd</span>
                                            </div>
                                            <div class="col-2 pt-1 xtc">
                                                <input type="radio" id="upc">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-4 justify mt-3 tfcdg">
                                <div class="tfcdb pb-2 tf-16">Tips</div>
                                <p>Welcome to use the quick recharge mode, please use APP to complete the payment of
                                    <span id="rcmtl">420</span></p>
                                <p>The transaction funds are guaranteed by the FastWin platform throughout the process,
                                    which is very safe.</p>
                                <p>Please do not include any words in remarks.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>

</template>
